import { render, staticRenderFns } from "./BStatusBadge.vue?vue&type=template&id=548b517b&"
import script from "./BStatusBadge.vue?vue&type=script&lang=js&"
export * from "./BStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports